/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Company_UserCompanyDto } from '../models/Wealthlane_CustomerService_Dtos_Company_UserCompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantCompanyAppserviceService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Company_UserCompanyDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantCompanyAppserviceMyCompanies(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_Company_UserCompanyDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-company-appservice/my-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
